import { render, staticRenderFns } from "./TrxSummery.vue?vue&type=template&id=07256119"
import script from "./TrxSummery.vue?vue&type=script&lang=js"
export * from "./TrxSummery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports